import { theme } from '../../theme'

export const addSVG = (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 1L5 9M9 5L1 5" stroke={theme.colors.primary} strokeWidth="2" strokeLinecap="round" />
  </svg>
)
